import * as React from 'react';
import { uniTestkitFactoryCreator } from '@wix/wix-ui-test-utils/vanilla';
import { CardWiringExample } from './CardWiringExample';
import { visualize, story, snap } from 'storybook-snapper';
import { cardDriverFactory, CardDriver } from './Card.driver';
import { Card, CardProps } from '..';
import classnames from 'classnames';
import { Text } from '../Text';
import { classes } from './Card.visual.st.css';
import { ImageResizeOptions, ThumbnailImage } from '../ThumbnailImage';

const createDriver = uniTestkitFactoryCreator(cardDriverFactory);
const dataHook = 'storybook-e2e-Card';

interface CardVisualProps {
  cardProps: CardProps;
}

class CardVisual extends React.Component<CardVisualProps> {
  static defaultProps = {
    cardProps: {},
  };
  // @ts-expect-error
  private driver: CardDriver;

  componentDidMount(): void {
    this.driver = createDriver({ wrapper: document.body, dataHook });
  }

  render() {
    return <CardWiringExample />;
  }
}

const CardTest = (props) => {
  return (
    <Card
      className={classnames(classes.root, {
        [classes.ratio20_80]: props.ratio20_80,
        [classes.ratio40_60]: props.ratio40_60,
      })}
      {...props}
    >
      <Card.Container className={classes.media}>
        <ThumbnailImage
          src="c5f754_23cf5dfa1ea44dc09e87a03df0996f83~mv2.png"
          alt="My product"
          width={400}
          height={520}
          fluid
          resize={ImageResizeOptions.cover}
        />
      </Card.Container>
      <Card.Container className={classes.info}>
        <Text>Info part</Text>
      </Card.Container>
    </Card>
  );
};

visualize('Card', () => {
  story('render', () => {
    snap('all states', <CardVisual />);
    snap('default layout', <CardTest />);
    snap('Card ratio 20/80', <CardTest ratio20_80 />);
    snap('Card ratio 40/60', <CardTest ratio40_60 />);
  });
});
